// extracted by mini-css-extract-plugin
module.exports = {"logo":"company-logo_logo__2Sn05","logo_sidebar":"company-logo_logo_sidebar__H9rZY","img":"company-logo_img__2U-nd"};